<template>
  <BaseScreen v-bind="screen">
    <BaseAlert
      v-if="isErrorVisible"
      v-bind="error"
      slot="middle"
    />
    <Performance
      v-else
      v-bind="performance"
      class="screen__strech screen__offset-right"
    >
      <template #actions>
        <BaseButton
          v-for="(item, i) in actions"
          :key="`action_${i}`"
          :text="item.text"
          is-light
          size="s"
          @click="item.action"
        />
      </template>
    </Performance>
  </BaseScreen>
</template>

<script>
import { mapState } from 'vuex';

import screenMixin from '@/mixins/screen';
import Performance from '@/components/Performance.vue';
import BaseButton from '@/components/BaseButton.vue';

import CONSTANTS from '@/helpers/constants';

const {
  ACTION_PICK,
} = CONSTANTS;

export default {
  name: 'PerformanceScreen',
  mixins: [screenMixin],
  components: {
    Performance,
    BaseButton,
  },
  computed: {
    ...mapState('cart', [
      'event',
    ]),
    title() {
      return this.$t('titles.spectacleInfo');
    },
    actions() {
      return [
        {
          text: this.$t('actions.buyTicket'),
          action: this.buyTicket,
        },
        {
          text: this.$t('actions.toEventsList'),
          action: this.goToEventsScreen,
        },
      ];
    },
    error() {
      return {
        title: this.$t('titles.badConnection'),
        text: this.$t('texts.buyNotPossible'),
        actions: [
          {
            text: this.$t('actions.home'),
            action: () => this.$router.push(this.$router.options.paths.home),
          },
        ],
      };
    },
    isErrorVisible() {
      return !this.performance;
    },
    performance() {
      return this.event?.performance;
    },
  },
  created() {
    this.initActions();
  },
  methods: {
    goToEventsScreen() {
      return this.$router.push(this.$router.options.paths.events);
    },
    buyTicket() {
      return this.$router.push({
        path: this.$router.options.paths.events,
        query: { name: this.performance?.title },
      });
    },
    initActions() {
      const rootActions = [
        [ACTION_PICK, this.buyTicket],
      ];

      rootActions.forEach((action) => this.$root.$on(...action));

      this.$once('hook:beforeDestroy', () => {
        rootActions.forEach((action) => this.$root.$off(...action));
      });
    },
  },
};
</script>
